// extracted by css-extract-rspack-plugin
export default {"overlay":"src-components-Nav-assets-nav-module__overlay-depZnP","open":"src-components-Nav-assets-nav-module__open-n_KkA_"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"overlay\":\"src-components-Nav-assets-nav-module__overlay-depZnP\",\"open\":\"src-components-Nav-assets-nav-module__open-n_KkA_\"}";
        // 1772473572971
        var cssReload = require("../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  